/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { Button, ButtonProps, ButtonType } from '@vaisala-rockhopper/components';
import './CTAButton.scss';

export interface CTAButtonProps extends ButtonProps {
  onButtonClick?: () => void;
  variant?: 'light' | 'dark';
  color?: 'aqua-medium' | 'orange-dark' | 'leaf-green';
}

const CTAButton = ({ onButtonClick, ...props }: CTAButtonProps) => {
  return (
    <Button
      onClick={onButtonClick}
      buttonType={ButtonType.Primary}
      {...props}
      className={`cta-button cta-button-${props.variant ?? 'light'} ${props.className ?? ''} cta-button-color-${props.color ?? 'aqua-medium'}`}
    >
      {props.children}
    </Button>
  );
};

export default CTAButton;
